import React, { useEffect } from 'react';
import { ForwardedProps, AnimatedValue } from 'react-spring';
import useKeyPress from '../../hooks/useKeyPress';
import useLockBodyScroll from '../../hooks/useLockBodyScroll';
import OverlayContainer from './styles/Overlay.style';

interface OverlayProps {
  props: AnimatedValue<ForwardedProps<ForwardedProps<React.CSSProperties>>>;
  isOpen: boolean;
  zIndex: number;
  handleIsOpen: () => void;
  children: React.ReactNode;
}

const Overlay: React.FC<OverlayProps> = ({ props, isOpen, zIndex, handleIsOpen, children }) => {
  useLockBodyScroll(isOpen);

  const escapePress = useKeyPress('Escape', isOpen);

  useEffect(() => {
    if (escapePress) handleIsOpen();
  }, [escapePress, handleIsOpen]);

  return (
    <OverlayContainer style={props} onClick={handleIsOpen} zindex={zIndex}>
      {children}
    </OverlayContainer>
  );
};

export default Overlay;
